import { type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';
import { CommandPaletteTrigger } from './CommandPaletteTrigger';

/**
 * Schlanker Skill-Descriptor — wird vom Bootstrap importiert, OHNE den Barrel
 * (CommandPalette + Such-API) eager zu ziehen. `CommandPaletteTrigger` (nur
 * Icon + Context-Setter) ist leicht und steht global in der Topbar, daher
 * direkter Import — analog zu `NotificationsBell`.
 */
const manifest: SkillManifest = {
  key: 'smart-search',
  name: 'Schnellsuche',
  description: 'Globale Suche (Strg+K) über Kunden, Projekte, Ansprechpartner und Dokumente.',
  category: 'data',
  version: '0.1.0',
  enabledByDefault: true,
};

export const smartSearchSkill: FrontendSkill = {
  manifest,
  slots: {
    'global.topbar': [
      {
        key: 'command-palette-trigger',
        order: 10,
        render: CommandPaletteTrigger,
      },
    ],
  },
};
